<template>
  
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
    created() {
      localStorage.removeItem("openid")
      localStorage.removeItem("token")
    },
  }
</script>

<style lang="less" scoped="scoped">
</style>



// WEBPACK FOOTER //
// src/components/unpublic/fxbuycode/deleteopid.vue